import { Container } from '@mui/material'
import React from 'react'
import { Outlet } from 'react-router-dom'
// import { createBreakpoints } from '@mui/system'
// const breakpoints = createBreakpoints({})
import theme from '../styles/theme/'
import { ThemeProvider } from '@mui/system'

// // https://mui.com/material-ui/guides/routing/
// //'rgba(78, 187, 180, 0.25)', beautiful robins egg
// const theme = createTheme({
//     palette: {
//         primary: {
//             main: '#005247',
//             light: '#4ebbb4',
//             dark: '#006e64',
//             // contrastText: '#fff',
//         },
//         secondary: {
//             main: '#fff179',
//             light: '#fef4e9',
//             dark: '#825735',
//             // contrastText: '#000',
//         },
//
//         // @ts-ignore
//         companyColors: {
//             accent: '#800000',
//             contrastText: '#000',
//         },

//         /*
//     --clrGreen: #005247;
//     --clrGreenL: #4ebbb4;
//     --clrBrown: #825735;
//     --clrBeige: #ffe9cf;
//     --clrOrange: #d87c28;
//     --clrOrangeL1: #f6c995;
//     --clrOrangeL2: #ffe9cf;
//     --clrRed: #800000;
//     --clrRedL: #edc1c4;
//     --clrCopper: #b87333;

// */
//     },
//     components: {
//         MuiMenuItem: {
//             styleOverrides: {
//                 root: {
//                     ':hover': {
//                         backgroundColor: 'rgba(130, 87, 53, .13)',
//                         // fontWeight: '600',
//                         fontSize: 'larger',
//                     },
//                     '&.Mui-selected': {
//                         fontWeight: '600',
//                         backgroundColor: 'rgba(130, 87, 53, .22)',
//                     },
//                     '&.Mui-selected:hover': {
//                         fontWeight: '600',
//                         fontSize: 'larger',
//                         backgroundColor: 'rgba(130, 87, 53, .28)',
//                     },
//                     '&.Mui-selected:active': {
//                         fontWeight: '600',
//                         backgroundColor: 'rgba(130, 87, 53, .28)',
//                     },

//                     ':active': {
//                         backgroundColor: 'rgba(130, 87, 53, .13)',
//                         // fontWeight: '600',
//                         fontSize: 'larger',
//                     },
//                     '&.Mui-selected:focus': {
//                         fontWeight: '600',
//                         backgroundColor: 'rgba(130, 87, 53, .28)',
//                     },

//                     ':focus': {
//                         backgroundColor: 'rgba(130, 87, 53, .13)',
//                         // fontWeight: '600',
//                         fontSize: 'larger',
//                     },
//                 },
//             },
//         },
//     },
//     typography: {
//         body1: {
//             // color: 'red',
//             // fontSize: '1rem',

//             [breakpoints.up('xs')]: {
//                 // color: 'pink',
//                 fontSize: '0.85rem',
//             },

//             [breakpoints.up('sm')]: {
//                 // color: 'red',
//                 fontSize: '0.85rem',
//             },
//             [breakpoints.up('md')]: {
//                 // color: 'blue',
//                 fontSize: '0.9rem',
//             },
//             [breakpoints.up('lg')]: {
//                 // color: 'green',
//                 fontSize: '1rem',
//             },
//         },
//         // h6: {
//         //     color: 'red',
//         // },

//         // h4: {
//         //     color: 'red',
//         // },

//         // subtitle1: {
//         //     color: 'red',
//         // },
//     },
// })

export default function Landing() {
    return (
        <Container maxWidth="lg">
            <ThemeProvider theme={theme}>
                <Outlet />
            </ThemeProvider>
        </Container>
    )
}
